import { Fragment, FunctionComponent, h } from 'preact'
import { RoutableProps } from 'preact-router'

export const About: FunctionComponent<RoutableProps> = () => {
  return (
    <Fragment>
      <section className="section">
        <div className="section-title">IEEE</div>
        <p>
          IEEE(Institute of Electrical and Electronics
          Engineers)は、アメリカに本部を置く電気電子系の世界最大級の学会で世界中の研究者や学生などが会員として活動しています。
          IEEE学生会員の年会費は$27.00であり、一般会員の年会費（$154.00）に比べて低額で入会できます。また、学生は39のSocietyに通常の半額で加入することができるだけでなく、IEEE
          Societyの刊行物も大幅に割引されるメリットがあります。
        </p>
      </section>
      <section className="section">
        <div className="section-title">IEEE Hiroshima Section Student Branch</div>
        <p>
          IEEEの活動組織の一つであり、サークル活動に近い意味合いがあります。学生自ら様々な企画運営ができる他、
          他のBranchの学生や教職員、社会で活躍している専門家等と会い、学び、また交流することによって、色々なプロジェクト、
          会議、見学、旅行等の活動を通して、多くの教育的、技術的、専門的な刺激を得ることができ、
          国内活動のみならず世界へ通じるチャネルをもてるという利点があります。日本国内にあるIEEE Student Branch は31大学
          （2017年4月時点）。各大学 には、カウンセラー（Counselor）の先生がおり、 学生活動の支援にあたっています。
          IEEE広島支部学生ブランチは山陰に位置する鳥取大学と島根大学が共同で運営する学生ブランチとしてIEEE広島支部のもとで設立されました。
        </p>
      </section>
    </Fragment>
  )
}
